// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "swiper/dist/css/swiper.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import store from './store';
import $ from 'jquery';

import VueSweetalert2 from './plugins/vue-sweetalert2'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueSweetalert2)

const hostList = [
    { website: 'dawntech-info.cn', siteNo: '苏ICP备2021042397号-1', siteNo1: '苏公网安备32050802011825号' },
    { website: 'dawntech-info.net', siteNo: '苏ICP备2021042397号-2', siteNo1: '苏公网安备32050802011826号' },
    { website: 'dawntechinfo.com', siteNo: '苏ICP备2021042397号-3', siteNo1: '苏公网安备32050802011827号' },
    { website: 'dawntechinfo.cn', siteNo: '苏ICP备2021042397号-4', siteNo1: '苏公网安备32050802011828号' },
    { website: 'dawntech-info.com', siteNo: '苏ICP备2021042397号-5', siteNo1: '苏公网安备32050802011829号' },
    { website: 'dawntechinfo.net', siteNo: '苏ICP备2021042397号-6', siteNo1: '苏公网安备32050802011830号' },
]

const host = window.location.host;
const hostObj = hostList.find(obj => host.indexOf(obj.website) >= 0) || hostList[4];

Vue.prototype.website = `www.${hostObj.website}`;
Vue.prototype.siteNo = hostObj.siteNo;
Vue.prototype.siteNo1 = hostObj.siteNo1;

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js